// Single source of truth for backend URLs. Uses an environment variable so
// dev/staging/production can point at different backends without code changes
// (set REACT_APP_API_URL in .env.local for local dev, or in your build
// environment for production). Falls back to the live AWS backend if unset.
const API_ROOT =
  process.env.REACT_APP_API_URL ||
  "http://tour-site-env.eba-muse69my.ap-south-1.elasticbeanstalk.com";

// Base for all Laravel API calls, e.g. `${BASE_URL}/tour`, `${BASE_URL}/log_in`
export const BASE_URL = `${API_ROOT}/api/user`;

// Base for tour images. Laravel's public/ folder is the actual web root now,
// so this does NOT include a "/public" path segment.
export const IMAGE_BASE_URL = `${API_ROOT}/Images/Tour`;
